import { getClientsSnapshot } from '../../api'
import findClientCodeUseCase from '../findClientCodeUseCase'

export const SET_ALL_DATA = 'SET_ALL_DATA'
export const SET_ITEM = 'SET_ITEM'
export const DELETE_ITEM = 'DELETE_ITEM'

const setAllData = payload => (
    { type: SET_ALL_DATA, payload }
)

const setItem = payload => (
    { type: SET_ITEM, payload }
)

const deleteItem = payload => (
    { type: DELETE_ITEM, payload }
)

export const getClients = payload => {
    return async (dispatch, getState) => {
        const codClientInitial = await findClientCodeUseCase()

        getClientsSnapshot(snapshot => {
            const { added, modified, removed } = getDataFromSnapshot(snapshot, codClientInitial)

            if (getState().clients.data.length === 0) {
                dispatch(setAllData(added))
            } else {
                Object.entries(added).forEach(([key, value]) => dispatch(setItem({ id: key, data: value })));
                Object.entries(modified).forEach(([key, value]) => dispatch(setItem({ id: key, data: value })));
                Object.entries(removed).forEach(([key, value]) => dispatch(deleteItem({ id: key })));
            }
        })
    }
}

const getDataFromSnapshot = (snapshot, codClientInitial) => {
    let data = {
        added: {},
        modified: {},
        removed: {}
    }

    snapshot.docChanges().forEach(change => {
        const type = data[change.type]
        type[change.doc.id] = applyTransformData(change.doc.data(), codClientInitial)
    })

    return data
}

const applyTransformData = (client, codClientInitial) => {
    if (client.codClient) {
        return client
    }
    return { ...client, codClient: codClientInitial + client.numberClient }
}